import { FwVersionContentAndMetadata } from 'src/dtos/version.dto';
import axiosService from './axios-service';

class FwRulesService {
    public createIp = async (customerId: number, sid: number, versionId: string, body: any, endpointName: string,): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/${endpointName}`, {
            ...body,
            externalId: versionId
        });
        return result?.data;
    };

    public deleteIp = async (customerId: number, sid: number, versionId: string, body: any, endpointName: string,): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/${endpointName}`, {
            ...body,
            externalId: versionId
        });
        return result?.data;
    };

    public updateIp = async (customerId: number, sid: number, versionId: string, body: any, endpointName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/${endpointName}`, {
            ...body,
            externalId: versionId
        });
        return result?.data;
    };
}

const fwRulesService = new FwRulesService();
export default fwRulesService;

